@if (mode() === 'trigger') {
<button type="button" #findCreatorsFiltersButton command="show-modal" commandfor="findCreatorsFiltersDrawer"
    (click)="openPanel()" class="fab-button-flashy-go inline-flex items-center gap-1.5 px-3" aria-haspopup="dialog"
    aria-label="Filters" aria-controls="findCreatorsFiltersDrawer">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
        <path
            d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
    </svg>
    <p class="m-0 text-sm font-medium">Filters</p>
    @if (activeChipCount() > 0) {
    <p class="m-0 rounded-full bg-white text-[#7421FB] px-1.5 py-0.5 text-xxs leading-none">{{ activeChipCount() }}
    </p>
    }
</button>

<el-dialog>
    <dialog #findCreatorsFiltersDialog id="findCreatorsFiltersDrawer" aria-labelledby="findCreatorsFiltersDrawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">

        <el-dialog-backdrop
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>

        <div tabindex="0" class="absolute inset-0 pr-10 focus:outline-none sm:pr-16 z-20 cursor-pointer"
            (click)="closePanel()">
            <el-dialog-panel
                class="mr-auto block size-full max-w-lg transform transition-transform ease-in-out data-closed:-translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-hidden bg-[var(--card)] shadow-xl rounded-xl">
                    <div class="h-full flex flex-col overflow-hidden divide-y divide-border">

                        <div class="px-2 py-4 drawer-header-primary shrink-0">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p id="findCreatorsFiltersDrawer-title"
                                        class="m-0 text-md font-semibold text-primary">
                                        Filter creators
                                    </p>
                                    <p class="m-0 text-sm text-secondary">
                                        Use filters to narrow your search.
                                    </p>
                                </div>
                                <div class="h-full flex flex-col justify-between items-end">
                                    <button type="button" (click)="closePanel()"
                                        class="fab-button-secondary text-secondary" aria-label="Close filters">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5"
                                            aria-hidden="true">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            class="relative min-h-0 flex-1 flex flex-col gap-4 overflow-y-auto drawer-body-primary px-4 py-3">

                            <fieldset class="m-0 p-0 border-0">
                                <legend class="text-sm font-medium text-secondary mb-1.5">Country</legend>
                                <div class="flex flex-wrap items-center gap-1.5">
                                    <button type="button" (click)="selectCountry(null)"
                                        [class]="filterChipClass(draft().country === null)">
                                        Any
                                    </button>
                                    @for (country of countryOptions; track country.id) {
                                    <button type="button" (click)="selectCountry(country.id)"
                                        [class]="filterChipClass(draft().country === country.id)">
                                        {{ country.name }}
                                    </button>
                                    }
                                </div>
                            </fieldset>

                            <fieldset class="m-0 p-0 border-0">
                                <legend class="text-sm font-medium text-secondary mb-1.5">Gender</legend>
                                <div class="flex flex-wrap items-center gap-1.5">
                                    <button type="button" (click)="selectGender(null)"
                                        [class]="filterChipClass(draft().gender === null)">
                                        Any
                                    </button>
                                    @for (gender of genderOptions; track gender.id) {
                                    <button type="button" (click)="selectGender(+gender.id)"
                                        [class]="filterChipClass(draft().gender === gender.id)">
                                        {{ gender.name }}
                                    </button>
                                    }
                                </div>
                            </fieldset>

                            <fieldset class="m-0 p-0 border-0">
                                <legend class="text-sm font-medium text-secondary mb-1.5">Minimum rating</legend>
                                <div class="flex flex-wrap items-center gap-1.5">
                                    <button type="button" (click)="selectRating(null)"
                                        [class]="filterChipClass(draft().rating === null)">
                                        Any
                                    </button>
                                    @for (option of ratingOptions; track option.value) {
                                    <button type="button" (click)="selectRating(option.value)"
                                        [class]="filterChipClass(draft().rating === option.value)">
                                        {{ option.label }}
                                    </button>
                                    }
                                </div>
                            </fieldset>

                            <div class="flex flex-col gap-1.5">
                                <div class="flex items-center justify-between gap-2">
                                    <label class="text-sm font-medium text-primary">Age</label>
                                    <p class="m-0 text-sm font-medium text-primary">
                                        {{ ageSlider.minValue }} – {{ ageSlider.maxValue }}
                                    </p>
                                </div>
                                <div class="flex flex-row items-center w-full">
                                    <mat-slider class="flex-1" [disabled]="ageRangeSliderDefaults.disabled"
                                        [max]="ageRangeSliderDefaults.max" [min]="ageRangeSliderDefaults.min"
                                        [step]="ageRangeSliderDefaults.step"
                                        [discrete]="ageRangeSliderDefaults.thumbLabel"
                                        [showTickMarks]="ageRangeSliderDefaults.showTicks" aria-label="Age range">
                                        <input [(ngModel)]="ageSlider.minValue"
                                            (ngModelChange)="onAgeRangeChange($event, 'min')"
                                            [ngModelOptions]="{standalone: true}" matSliderStartThumb>
                                        <input [(ngModel)]="ageSlider.maxValue"
                                            (ngModelChange)="onAgeRangeChange($event, 'max')"
                                            [ngModelOptions]="{standalone: true}" matSliderEndThumb>
                                    </mat-slider>
                                </div>
                                <div class="flex justify-between gap-1">
                                    <p class="m-0 text-[10px] text-secondary">{{ ageRangeSliderDefaults.min }}</p>
                                    <p class="m-0 text-[10px] text-secondary">{{ ageRangeSliderDefaults.max }}</p>
                                </div>
                            </div>

                            <div class="flex flex-col gap-1.5">
                                <label for="find-creators-hometown"
                                    class="text-sm font-medium text-secondary">Hometown</label>
                                <input id="find-creators-hometown" type="text" class="input-primary w-full text-sm"
                                    placeholder="e.g. Manchester" [value]="draft().homeTownSearchTerm"
                                    (input)="onHometownInput($any($event.target).value)" />
                            </div>

                            <div class="flex flex-col gap-3">
                                <label class="flex items-center justify-between gap-3 cursor-pointer">
                                    <p class="m-0 text-sm font-medium text-primary">Verified only</p>
                                    <button type="button" role="switch" [attr.aria-checked]="draft().isVerified"
                                        (click)="setVerifiedOnly(!draft().isVerified)"
                                        class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                        [class]="draft().isVerified ? 'bg-primary' : 'bg-zinc-200 dark:bg-zinc-700'">
                                        <span
                                            class="inline-block size-5 transform rounded-full bg-white shadow-sm transition-transform"
                                            [class]="draft().isVerified ? 'translate-x-5' : 'translate-x-0.5'"></span>
                                    </button>
                                </label>
                                <label class="flex items-center justify-between gap-3 cursor-pointer">
                                    <p class="m-0 text-sm font-medium text-primary">Has reviews</p>
                                    <button type="button" role="switch" [attr.aria-checked]="draft().hasReviews"
                                        (click)="setHasReviews(!draft().hasReviews)"
                                        class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                        [class]="draft().hasReviews ? 'bg-primary' : 'bg-zinc-200 dark:bg-zinc-700'">
                                        <span
                                            class="inline-block size-5 transform rounded-full bg-white shadow-sm transition-transform"
                                            [class]="draft().hasReviews ? 'translate-x-5' : 'translate-x-0.5'"></span>
                                    </button>
                                </label>
                            </div>

                            <fieldset class="m-0 p-0 border-0">
                                <legend class="text-sm font-medium text-secondary mb-1.5">Niches</legend>
                                <div class="flex flex-wrap gap-1.5">
                                    @for (niche of nicheOptions; track niche.id) {
                                    <button type="button" (click)="toggleInterest(+niche.id)"
                                        class="rounded-md border px-2.5 py-1.5 text-sm font-medium transition-colors"
                                        [class]="isInterestSelected(+niche.id)
                            ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                            : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                        {{ niche.name }}
                                    </button>
                                    }
                                </div>
                            </fieldset>

                            <div class="flex flex-col gap-4 border-t border-zinc-200 dark:border-white/10 pt-3">
                                <div class="flex rounded-full bg-zinc-100 dark:bg-zinc-800 p-1" role="tablist"
                                    aria-label="Platform stats">
                                    @for (tab of platformTabs; track tab.id) {
                                    <button type="button" role="tab" (click)="selectPlatform(tab.id)"
                                        class="flex min-w-0 flex-1 items-center justify-center gap-1 rounded-full px-1 py-1.5 text-[11px] font-medium transition-colors sm:gap-1.5 sm:px-2 sm:text-sm"
                                        [class]="platformTabClass(tab.id)"
                                        [attr.aria-selected]="selectedPlatform() === tab.id"
                                        [attr.aria-label]="tab.label">
                                        <img [src]="tab.iconSrc" alt="" class="size-3.5 shrink-0" aria-hidden="true" />
                                        <span class="truncate">{{ tab.label }}</span>
                                    </button>
                                    }
                                </div>

                                <div class="flex flex-col gap-1.5">
                                    <div class="flex items-center justify-between gap-2">
                                        <label
                                            class="inline-flex items-center gap-1.5 text-sm font-medium text-primary">
                                            <img [src]="selectedFollowerIcon()" alt="" class="size-4"
                                                aria-hidden="true" />
                                            Followers
                                        </label>
                                        <p class="m-0 text-sm font-medium text-primary">
                                            {{ formatFollowerStep(selectedFollowerSlider().minValue) }} –
                                            {{ formatFollowerStep(selectedFollowerSlider().maxValue) }}
                                        </p>
                                    </div>
                                    <div class="flex flex-row items-center w-full">
                                        <mat-slider class="flex-1" [disabled]="followerRangeSliderDefaults.disabled"
                                            [max]="followerRangeSliderDefaults.max"
                                            [min]="followerRangeSliderDefaults.min"
                                            [step]="followerRangeSliderDefaults.step"
                                            [discrete]="followerRangeSliderDefaults.thumbLabel"
                                            [showTickMarks]="followerRangeSliderDefaults.showTicks"
                                            [attr.aria-label]="selectedFollowerLabel() + ' follower range'">
                                            <input [(ngModel)]="selectedFollowerSlider().minValue"
                                                (ngModelChange)="onSelectedFollowerRangeChange($event, 'min')"
                                                [ngModelOptions]="{standalone: true}" matSliderStartThumb>
                                            <input [(ngModel)]="selectedFollowerSlider().maxValue"
                                                (ngModelChange)="onSelectedFollowerRangeChange($event, 'max')"
                                                [ngModelOptions]="{standalone: true}" matSliderEndThumb>
                                        </mat-slider>
                                    </div>
                                    <div class="flex justify-between gap-1">
                                        @for (label of followerStepLabels; track label) {
                                        <p class="m-0 text-[10px] text-secondary">{{ label }}</p>
                                        }
                                    </div>
                                </div>

                                @if (performancePlatform(); as platform) {
                                <div class="flex flex-col gap-1.5">
                                    <label for="find-creators-engagement"
                                        class="text-sm font-medium text-secondary">Engagement
                                        rate</label>
                                    <select id="find-creators-engagement" class="input-primary w-full text-sm"
                                        [value]="currentPerformance().averageEngagement ?? ''"
                                        (change)="onEngagementSelect($any($event.target).value)">
                                        @for (option of engagementRateOptions; track option.label) {
                                        <option [value]="option.value ?? ''">{{ option.label }}</option>
                                        }
                                    </select>
                                </div>

                                <div class="flex flex-col gap-1.5">
                                    <div class="flex items-center justify-between gap-2">
                                        <label class="text-sm font-medium text-primary">Average views</label>
                                        <p class="m-0 text-sm font-medium text-primary">
                                            {{ formatPerformanceStep(performanceSlider('averageViews').minValue) }} –
                                            {{ formatPerformanceStep(performanceSlider('averageViews').maxValue) }}
                                        </p>
                                    </div>
                                    <div class="flex flex-row items-center w-full">
                                        <mat-slider class="flex-1" [disabled]="performanceRangeSliderDefaults.disabled"
                                            [max]="performanceRangeSliderDefaults.max"
                                            [min]="performanceRangeSliderDefaults.min"
                                            [step]="performanceRangeSliderDefaults.step"
                                            [discrete]="performanceRangeSliderDefaults.thumbLabel"
                                            [showTickMarks]="performanceRangeSliderDefaults.showTicks"
                                            aria-label="Average views range">
                                            <input [(ngModel)]="performanceSlider('averageViews').minValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'averageViews', $event, 'min')"
                                                [ngModelOptions]="{standalone: true}" matSliderStartThumb>
                                            <input [(ngModel)]="performanceSlider('averageViews').maxValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'averageViews', $event, 'max')"
                                                [ngModelOptions]="{standalone: true}" matSliderEndThumb>
                                        </mat-slider>
                                    </div>
                                    <div class="flex justify-between gap-1">
                                        @for (label of performanceTickLabels; track label) {
                                        <p class="m-0 text-[10px] text-secondary">{{ label }}</p>
                                        }
                                    </div>
                                </div>

                                <div class="flex flex-col gap-1.5">
                                    <div class="flex items-center justify-between gap-2">
                                        <label class="text-sm font-medium text-primary">Total views</label>
                                        <p class="m-0 text-sm font-medium text-primary">
                                            {{ formatPerformanceStep(performanceSlider('totalViews').minValue) }} –
                                            {{ formatPerformanceStep(performanceSlider('totalViews').maxValue) }}
                                        </p>
                                    </div>
                                    <div class="flex flex-row items-center w-full">
                                        <mat-slider class="flex-1" [disabled]="performanceRangeSliderDefaults.disabled"
                                            [max]="performanceRangeSliderDefaults.max"
                                            [min]="performanceRangeSliderDefaults.min"
                                            [step]="performanceRangeSliderDefaults.step"
                                            [discrete]="performanceRangeSliderDefaults.thumbLabel"
                                            [showTickMarks]="performanceRangeSliderDefaults.showTicks"
                                            aria-label="Total views range">
                                            <input [(ngModel)]="performanceSlider('totalViews').minValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'totalViews', $event, 'min')"
                                                [ngModelOptions]="{standalone: true}" matSliderStartThumb>
                                            <input [(ngModel)]="performanceSlider('totalViews').maxValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'totalViews', $event, 'max')"
                                                [ngModelOptions]="{standalone: true}" matSliderEndThumb>
                                        </mat-slider>
                                    </div>
                                    <div class="flex justify-between gap-1">
                                        @for (label of performanceTickLabels; track label) {
                                        <p class="m-0 text-[10px] text-secondary">{{ label }}</p>
                                        }
                                    </div>
                                </div>

                                <div class="flex flex-col gap-1.5">
                                    <div class="flex items-center justify-between gap-2">
                                        <label class="text-sm font-medium text-primary">Average likes</label>
                                        <p class="m-0 text-sm font-medium text-primary">
                                            {{ formatPerformanceStep(performanceSlider('averageLikes').minValue) }} –
                                            {{ formatPerformanceStep(performanceSlider('averageLikes').maxValue) }}
                                        </p>
                                    </div>
                                    <div class="flex flex-row items-center w-full">
                                        <mat-slider class="flex-1" [disabled]="performanceRangeSliderDefaults.disabled"
                                            [max]="performanceRangeSliderDefaults.max"
                                            [min]="performanceRangeSliderDefaults.min"
                                            [step]="performanceRangeSliderDefaults.step"
                                            [discrete]="performanceRangeSliderDefaults.thumbLabel"
                                            [showTickMarks]="performanceRangeSliderDefaults.showTicks"
                                            aria-label="Average likes range">
                                            <input [(ngModel)]="performanceSlider('averageLikes').minValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'averageLikes', $event, 'min')"
                                                [ngModelOptions]="{standalone: true}" matSliderStartThumb>
                                            <input [(ngModel)]="performanceSlider('averageLikes').maxValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'averageLikes', $event, 'max')"
                                                [ngModelOptions]="{standalone: true}" matSliderEndThumb>
                                        </mat-slider>
                                    </div>
                                    <div class="flex justify-between gap-1">
                                        @for (label of performanceTickLabels; track label) {
                                        <p class="m-0 text-[10px] text-secondary">{{ label }}</p>
                                        }
                                    </div>
                                </div>

                                <div class="flex flex-col gap-1.5">
                                    <div class="flex items-center justify-between gap-2">
                                        <label class="text-sm font-medium text-primary">Total likes</label>
                                        <p class="m-0 text-sm font-medium text-primary">
                                            {{ formatPerformanceStep(performanceSlider('totalLikes').minValue) }} –
                                            {{ formatPerformanceStep(performanceSlider('totalLikes').maxValue) }}
                                        </p>
                                    </div>
                                    <div class="flex flex-row items-center w-full">
                                        <mat-slider class="flex-1" [disabled]="performanceRangeSliderDefaults.disabled"
                                            [max]="performanceRangeSliderDefaults.max"
                                            [min]="performanceRangeSliderDefaults.min"
                                            [step]="performanceRangeSliderDefaults.step"
                                            [discrete]="performanceRangeSliderDefaults.thumbLabel"
                                            [showTickMarks]="performanceRangeSliderDefaults.showTicks"
                                            aria-label="Total likes range">
                                            <input [(ngModel)]="performanceSlider('totalLikes').minValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'totalLikes', $event, 'min')"
                                                [ngModelOptions]="{standalone: true}" matSliderStartThumb>
                                            <input [(ngModel)]="performanceSlider('totalLikes').maxValue"
                                                (ngModelChange)="onPerformanceRangeChange(platform, 'totalLikes', $event, 'max')"
                                                [ngModelOptions]="{standalone: true}" matSliderEndThumb>
                                        </mat-slider>
                                    </div>
                                    <div class="flex justify-between gap-1">
                                        @for (label of performanceTickLabels; track label) {
                                        <p class="m-0 text-[10px] text-secondary">{{ label }}</p>
                                        }
                                    </div>
                                </div>
                                }
                            </div>

                        </div>

                        <div class="p-3 drawer-header-primary shrink-0">
                            <div class="flex items-center justify-end gap-2">
                                <button type="button" (click)="clearFilters()"
                                    class="btn-shout btn-shout-xs btn-shout-secondary">
                                    Clear
                                </button>
                                <button type="button" (click)="applyFilters()"
                                    class="btn-shout btn-shout-xs btn-shout-primary">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog-panel>
        </div>
    </dialog>
</el-dialog>
}

@if (mode() === 'chips' && activeChips().length > 0) {
<div class="flex min-w-0 flex-1 flex-row items-center justify-start gap-2 overflow-x-auto py-1"
    aria-label="Active filters">
    @for (chip of activeChips(); track chip.key) {
    <span
        class="gap-x-1 inline-flex items-center rounded-full bg-[#F0E6FE] dark:bg-primary/25 px-3 py-1 text-sm font-medium text-[#7421FB] dark:text-violet-200 whitespace-nowrap">
        <p class="m-0">{{ chip.label }}</p>
        <button (click)="removeChip(chip.key)" type="button"
            class="group relative -mr-0.5 size-3.5 rounded-xs hover:bg-[#7421FB]/15"
            [attr.aria-label]="'Remove ' + chip.label">
            <svg viewBox="0 0 14 14"
                class="size-3.5 stroke-[#7421FB]/70 group-hover:stroke-[#7421FB] dark:stroke-violet-200"
                aria-hidden="true">
                <path d="M4 4l6 6m0-6l-6 6" />
            </svg>
            <span class="absolute -inset-1"></span>
        </button>
    </span>
    }
    <button type="button" (click)="clearFilters()"
        class="text-sm font-medium text-[#7421FB] hover:text-[#5b1ac7] whitespace-nowrap px-1">
        Clear all
    </button>
</div>
}